<template>
  <div class="privacyPolicy">
    <div style="word-break:break-all;" v-html="decodeStrConStr"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      decodeStrConStr:''
    }
  },
  created () {
    document.title = '隐私政策'
    if (this.environment.isFengChao) {
      this.$cjc.showNavigation()
    }
    this.getAppUserPrivacy()
  },
  methods: {
    async getAppUserPrivacy(){
      const {data: { result, status, msg }} = await this.$store.dispatch('getAppUserPrivacy',{})
      console.log(result);
      if (status === 1000) {
        this.decodeStrConStr = result.decodeStrCon
        console.log(this.decodeStrConStr);
      }else{
        this.$Message.error(msg)
      }
    }
  }
}
</script>

<style lang="scss">
.privacyPolicy {
  height: 100vh;
  padding: 20px;
}
</style>